import React from 'react'

import { infoNote } from '@ui-kit/components/InfoNote/styles'
import { bgColor } from '@ui-kit/styles/colors'

import type { Props } from './types'

const InfoNote = (props: Props) => {
  const { container, childrenContainer } = infoNote()
  return (
    <div
      className={container({
        className: bgColor({ color: props.bgColor ?? 'grey200' }),
      })}
    >
      {props.icon}
      <div className={childrenContainer()}>{props.children}</div>
    </div>
  )
}

export default InfoNote
